import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { AuthorizationDTO, PrintContractDTO, RequestFormDTO } from '@app/requests/model/requests-model';
import {
  FORM_AUTO,
  FORM_BP,
  FORM_CONSUMO,
  FORM_GS,
  FORM_MG,
  FORM_MG_NO_SHOP,
  FORM_REPSOL,
} from '@app/@core/constants/requests.constants';
import { TpvBuyPrintRequestDTO, TpvResponseDTO } from '@app/revolving/model/revolving-model';

@Injectable()
export class PrintApi {
  constructor(private _http: HttpClient) {}

  postPrintRequest(request: RequestFormDTO, type: string): Observable<any> {
    let subUrlPrint = '';
    // let httpOptions;
    // if (
    //   request.insurance === '' ||
    //   (request.insurance === 'S' && request.optionTest === true && request.optionTestAccept === 'S') ||
    //   request['codpac'] === 'VA' ||
    //   request['codpac'] === 'VF' ||
    //   request['codpac'] === 'VP'
    // ) {
    //   httpOptions = { responseType: 'blob' as 'json' };
    // }

    if (type === FORM_AUTO) {
      subUrlPrint = environment.subUrlPrintAutos;
    } else if (type === FORM_BP) {
      subUrlPrint = environment.subUrlPrintBP;
    } else if (type === FORM_MG) {
      subUrlPrint = environment.subUrlPrintMGShopping;
    } else if (type === FORM_MG_NO_SHOP) {
      subUrlPrint = environment.subUrlPrintMGNoShopping;
    } else if (type === FORM_CONSUMO) {
      subUrlPrint = environment.subUrlPrintConsumptionPreparePrint;
    } else if (type === FORM_GS || type === FORM_REPSOL) {
      subUrlPrint = environment.subUrlPrintConsumptionPreparePrint;
    }

    return this._http.post<any>(environment.URL_BASE_REQUEST + subUrlPrint, request); //httpOptions);
  }

  postPrintAuthorization(request: AuthorizationDTO) {
    const httpOptions = { responseType: 'blob' as 'json' };
    return this._http.post<any>(
      environment.URL_BASE_REQUEST + environment.subUrlPrintAuthorization,
      request,
      httpOptions
    );
  }

  postTpvPrint(tpvResponseDTO: TpvBuyPrintRequestDTO) {
    const httpOptions = { responseType: 'blob' as 'json' };
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlTPVPrint, tpvResponseDTO, httpOptions);
  }

  postTpvRefundPrint(tpvResponseDTO: TpvBuyPrintRequestDTO) {
    const httpOptions = { responseType: 'blob' as 'json' };
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlTPVPrint, tpvResponseDTO, httpOptions);
  }

  postPrintContract(printContractDTO: PrintContractDTO) {
    const httpOptions = { responseType: 'blob' as 'json' };
    return this._http.post<any>(
      environment.URL_BASE_SIGNATURE + environment.subUrlPrintContract,
      printContractDTO,
      httpOptions
    );
  }
}
